(function () {
    'use strict';

    angular
        .module('sodCommon')
        .factory('action-full-structural-refresh', actionFunc);

    function actionFunc(AccessMainCtrl, Path) {
        return function() {
            const mainService = AccessMainCtrl.get('mainService');
            const currentPath = Path.getPathInfo();
            mainService.getStructure(currentPath);
        };
    }
})();